/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-03-22 18:20:32
 * @LastEditors: limin
 * @LastEditTime: 2021-04-01 10:41:44
 */
import request from './axios'
import {setId, sys } from './request.conf'

export default {

  /**
   * 将 vue 对象传递给 apiHelper
   */
  getVueInstance(vue) {
    request.setVueInstance(vue)
  },
  /**
   * 获取微信授权后的用户信息
   */
  getWxUserInfo(params) {
    return request.post('后端接口地址，需要换掉', {
      ...params
    })
  },
  setId(id){
    if(!id){
      console.error('没有id,请重新登录或联系管理员')
      return {};
    }

    const [userId,sessionId,source,lastPath,appId] = id.split('|');
    // setId(userId,sessionId,source,lastPath)
    return { userId, sessionId, source, config: { lastPath, appId } };
  },
  sys
}
